import Image from '@/components/Image';
import TextIllustrationColumns, { TextIllustrationColumnsProps } from '@/components/TextIllustrationColumns';
import { ModuleTextIllustrationColumns2Fragment, ModuleTextIllustrationColumnsFragment } from '@/graphql';
import { parseHtml } from '@/lib/parse-html';
import { getSingle, notEmpty } from '@/lib/typescript-helpers';
import { FC, ReactNode } from 'react';

interface TextIllustrationColumnsModuleProps {
  props: CraftModuleFragment<ModuleTextIllustrationColumnsFragment | ModuleTextIllustrationColumns2Fragment>;
}

const TextIllustrationColumnsModule: FC<TextIllustrationColumnsModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return (
    <TextIllustrationColumns
      heading={props.heading ?? undefined}
      columnHeadingStyle={
        (props.columnHeadingStyle as TextIllustrationColumnsProps['columnHeadingStyle']) ?? 'standard'
      }
      columnIllustrationSize={
        (props.columnIllustrationSize as TextIllustrationColumnsProps['columnIllustrationSize']) ?? 'standard'
      }
      columnTextStyle={(props.columnTextStyle as TextIllustrationColumnsProps['columnTextStyle']) ?? 'standard'}
      columns={
        props.columns?.filter(notEmpty).map((column) => {
          const asset = getSingle(column.illustration);
          let illustration: ReactNode;

          if (asset) {
            illustration = <Image src={asset.url!} width={asset.width ?? 0} height={asset.height ?? 0} alt="" />;
          }

          return {
            id: column?.id!,
            heading: column?.heading ?? undefined,
            content: parseHtml(column?.text),
            illustration,
          };
        }) ?? []
      }
    />
  );
};

export default TextIllustrationColumnsModule;
